const regions = [
  { name: 'USA & Canada', shops: 240, icon: 'ri-map-pin-2-line', image: 'https://public.readdy.ai/ai/img_res/a8433a0b70af90ff5b1ccf350df8a0d7.jpg' },
  { name: 'Australia & NZ', shops: 185, icon: 'ri-map-pin-2-line', image: 'https://readdy.ai/api/search-image?query=Australia%20Gold%20Coast%20surfing%20beach%20waves%20surfers%20lifestyle%20photography%20blue%20sky&width=500&height=320&seq=region_aus1&orientation=landscape' },
  { name: 'Europe', shops: 320, icon: 'ri-map-pin-2-line', image: 'https://readdy.ai/api/search-image?query=European%20surf%20spot%20Biarritz%20France%20surfing%20waves%20ocean%20lifestyle%20photography&width=500&height=320&seq=region_eu1&orientation=landscape' },
  { name: 'Asia Pacific', shops: 210, icon: 'ri-map-pin-2-line', image: 'https://readdy.ai/api/search-image?query=Bali%20Indonesia%20surfing%20tropical%20waves%20surfer%20lifestyle%20photography%20warm%20tropical&width=500&height=320&seq=region_asia1&orientation=landscape' },
  { name: 'Latin America', shops: 90, icon: 'ri-map-pin-2-line', image: 'https://readdy.ai/api/search-image?query=Costa%20Rica%20tropical%20surf%20beach%20surfing%20waves%20surfer%20lifestyle%20photography&width=500&height=320&seq=region_latam1&orientation=landscape' },
  { name: 'Rest of World', shops: 155, icon: 'ri-global-line', image: 'https://readdy.ai/api/search-image?query=remote%20surf%20destination%20worldwide%20tropical%20beach%20surfing%20waves%20exotic%20lifestyle&width=500&height=320&seq=region_row1&orientation=landscape' },
];

export default function AboutGlobal() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Global Reach</p>
          <h2 className="text-4xl md:text-5xl font-black text-stone-900">
            Wherever Waves Break,<br />
            <span className="text-[#0B5C4D]">PHIX Doctor Is There</span>
          </h2>
          <p className="text-stone-500 mt-4 max-w-lg mx-auto">
            1,200+ retail locations in 60+ countries. From Malibu to Mentawai to Mundaka.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 mb-12">
          {regions.map((r) => (
            <div key={r.name} className="group rounded-2xl overflow-hidden cursor-default">
              <div className="relative h-48 overflow-hidden">
                <img src={r.image} alt={r.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B2C26]/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-white font-black text-base">{r.name}</p>
                  <p className="text-[#FF6B35] text-sm font-semibold">{r.shops} retail locations</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Global stats */}
        <div className="bg-[#0B2C26] rounded-3xl p-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[['60+', 'Countries'], ['1,200+', 'Retailers'], ['40K+', 'Surfers'], ['2008', 'Founded']].map(([v, l]) => (
            <div key={l}>
              <p className="text-[#FF6B35] font-black text-4xl mb-1">{v}</p>
              <p className="text-stone-400 text-sm uppercase tracking-wider">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
